// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.94.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.94.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sunzi__image-record-header-QIlu0 {
  display: flex;
  justify-content: space-between;
  margin-top: 24px;
}
.sunzi__image-record-header-QIlu0 .sunzi__title-vEhwR {
  font-weight: 800;
  font-size: 16px;
  line-height: 16px;
  color: #000;
}
.sunzi__image-record-header-QIlu0 .sunzi__clear-u0ggr {
  font-weight: 800;
  font-size: 14px;
  line-height: 16px;
  color: var(--sunzi-theme-color);
  cursor: pointer;
}
.sunzi__image-record-detail-I67pr {
  padding-top: 4px;
  font-size: 12px;
  line-height: 16px;
  color: rgba(0, 0, 0, 0.4);
}
.sunzi__image-record-content-ZsEvb {
  display: flex;
  padding: 20px 0;
  overflow-y: auto;
}
.sunzi__image-record-content-ZsEvb .sunzi__option-layout-P8cid {
  padding-right: 15px;
}
.sunzi__image-record-content-ZsEvb .sunzi__option-layout-P8cid:last-child {
  padding-right: 0;
}
.sunzi__image-record-content-ZsEvb .sunzi__option-layout-P8cid .sunzi__background-ObVcG {
  position: relative;
  width: 60px;
  height: 60px;
  background-image: url('https://assets.sunzi.cool/new-mini-me/curtain.png');
  border: 1px solid rgba(0, 0, 0, 0.19);
  border-radius: 8px;
}
.sunzi__image-record-content-ZsEvb .sunzi__option-layout-P8cid .sunzi__background-ObVcG .sunzi__image-pBFET {
  width: 100%;
  height: 100%;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  cursor: pointer;
}
.sunzi__image-record-content-ZsEvb .sunzi__option-layout-P8cid .sunzi__background-ObVcG .sunzi__clear-icon-EDUs8 {
  position: absolute;
  top: -8px;
  right: -8px;
  width: 18px;
  height: 18px;
  background-color: #f5f5f5;
  border-radius: 50%;
  cursor: pointer;
  padding: 2px;
}
.sunzi__image-record-content-ZsEvb .sunzi__option-layout-P8cid .sunzi__background-ObVcG .sunzi__clear-icon-EDUs8 .sunzi__inner-CJo_d {
  border: 1px solid rgba(0, 0, 0, 0.06);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Zuploader/style.module.less"],"names":[],"mappings":"AACE;EACE,aAAA;EACA,8BAAA;EACA,gBAAA;AAAJ;AAHE;EAMI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;AAAN;AATE;EAaI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,+BAAA;EACA,eAAA;AADN;AAKE;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;AAHJ;AAME;EACE,aAAA;EACA,eAAA;EACA,gBAAA;AAJJ;AACE;EAMI,mBAAA;AAJN;AAMM;EACE,gBAAA;AAJR;AALE;EAaM,kBAAA;EACA,WAAA;EACA,YAAA;EACA,0EAAA;EACA,qCAAA;EACA,kBAAA;AALR;AAbE;EAqBQ,WAAA;EACA,YAAA;EACA,wBAAA;EACA,2BAAA;EACA,4BAAA;EACA,eAAA;AALV;AArBE;EA8BQ,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;AANV;AAhCE;EAwCU,qCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AALZ","sourcesContent":[".image-record {\n  &-header {\n    display: flex;\n    justify-content: space-between;\n    margin-top: 24px;\n\n    .title {\n      font-weight: 800;\n      font-size: 16px;\n      line-height: 16px;\n      color: #000;\n    }\n\n    .clear {\n      font-weight: 800;\n      font-size: 14px;\n      line-height: 16px;\n      color: var(--sunzi-theme-color);\n      cursor: pointer;\n    }\n  }\n\n  &-detail {\n    padding-top: 4px;\n    font-size: 12px;\n    line-height: 16px;\n    color: rgba(0, 0, 0, 0.4);\n  }\n\n  &-content {\n    display: flex;\n    padding: 20px 0;\n    overflow-y: auto;\n\n    .option-layout {\n      padding-right: 15px;\n\n      &:last-child {\n        padding-right: 0;\n      }\n\n      .background {\n        position: relative;\n        width: 60px;\n        height: 60px;\n        background-image: url('https://assets.sunzi.cool/new-mini-me/curtain.png');\n        border: 1px solid rgba(0, 0, 0, 0.19);\n        border-radius: 8px;\n\n        .image {\n          width: 100%;\n          height: 100%;\n          background-size: contain;\n          background-position: center;\n          background-repeat: no-repeat;\n          cursor: pointer;\n        }\n\n        .clear-icon {\n          position: absolute;\n          top: -8px;\n          right: -8px;\n          width: 18px;\n          height: 18px;\n          background-color: #f5f5f5;\n          border-radius: 50%;\n          cursor: pointer;\n          padding: 2px;\n          .inner {\n            border: 1px solid rgba(0, 0, 0, 0.06);\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            border-radius: 50%;\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"image-record-header": `sunzi__image-record-header-QIlu0`,
	"imageRecordHeader": `sunzi__image-record-header-QIlu0`,
	"title": `sunzi__title-vEhwR`,
	"clear": `sunzi__clear-u0ggr`,
	"image-record-detail": `sunzi__image-record-detail-I67pr`,
	"imageRecordDetail": `sunzi__image-record-detail-I67pr`,
	"image-record-content": `sunzi__image-record-content-ZsEvb`,
	"imageRecordContent": `sunzi__image-record-content-ZsEvb`,
	"option-layout": `sunzi__option-layout-P8cid`,
	"optionLayout": `sunzi__option-layout-P8cid`,
	"background": `sunzi__background-ObVcG`,
	"image": `sunzi__image-pBFET`,
	"clear-icon": `sunzi__clear-icon-EDUs8`,
	"clearIcon": `sunzi__clear-icon-EDUs8`,
	"inner": `sunzi__inner-CJo_d`
};
export default ___CSS_LOADER_EXPORT___;
